/**
 * lib-components
 *
 * Adapptio library to help creating components.
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { createContext } from "react";

/**
 * Map of icon packages to their respective URLs
 *
 * Examples:
 * ```
 * iconPackageUrlMapping: {
 *   "mdi": "https://cnd.hexio.cloud/media/icons/mdi",
 *   "app": "/media/icons"
 * }
 * ```
 */
export interface IIconPackageURLMapping {
	[K: string]: string;
}

/**
 * Media context
 */
export const MediaContext = createContext<{
	iconPackageUrlMapping: IIconPackageURLMapping;
}>(null);
